import { RECEIVABLE_LIST_LOADED, API_ERRORED } from "../constants/action-types";

const initialState = {
    list: []
};

function receivableReducer(state = initialState, action) {
    if(action.type === RECEIVABLE_LIST_LOADED) {
        return Object.assign({}, state, {
            list: action.payload
        });
    } else if(action.type === API_ERRORED) {
        return Object.assign({}, state, {
            //TODO: show error message, do not add it to the list
            list: [{id: 1, title: 'API ERROR'}]
        });
    } else {
        return state;
    }
};

export default receivableReducer;
